module.exports = __webpack_public_path__ + "img/browse.f1caa0f6.svg";